import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EcallSummaryComponent } from './ecall-summary';
import { EcallDetailComponent } from './ecall-detail';
import { EcallEditComponent } from './ecall-edit';
import { EcallCreateComponent } from './ecall-create';
import { EcallPdfSummaryComponent } from './ecall-pdf-summary/ecall-pdf-summary.component';
import { EcallPdfAddComponent } from './ecall-pdf-add/ecall-pdf-add.component';
import { Authguard } from '../../../helper';
import { Roles } from '../../../model';

const routes: Routes = [
  { path: '', redirectTo: 'summary', pathMatch: 'full' },
  {
    path: '',
    data: {
      title: 'Emergency Call'
    },
    children: [
      {
        path: 'summary',
        component: EcallSummaryComponent,
        data: { title: 'Summary' }
      },
      {
        path: 'summary/:customerId',
        component: EcallSummaryComponent,
        data: { title: 'Summary' }
      },
      {
        path: 'detail/:id',
        component: EcallDetailComponent,
        data: { title: 'Details' }
      },
      {
        path: 'edit/:id',
        component: EcallEditComponent,
        data: { title: 'Edit' }
      },
      {
        path: 'add',
        component: EcallCreateComponent,
        canActivate: [ Authguard ],
        data: {
          title: 'Add' ,
          permission: {
            role: [Roles.Admin, Roles.Engineer],
            redirectTo: '403'
          }
        }
     
        
      },
      {
        path: 'add/:id',
        component: EcallCreateComponent,
        data: { title: 'Add' }
      },
      {
        path: 'pdf/:id', 
        data: { title: 'PDF'},
        children: [{
          path: 'a',
          component: EcallPdfAddComponent,
          data: { title: 'Upload PDF' }
        }, {
          path: '',
          component: EcallPdfSummaryComponent,
        }],
       
      }      
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EcallRoutingModule { }



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/ecall/ecall-routing.module.ts